import { useMutation } from '@tanstack/react-query';
import { useServicesContext } from '../../contexts/ServicesContext';
import { ArticleDraftRequest } from '../../api/queries';

export enum CreateDraftMutationCacheKey {
  CreateDraftMutation = 'CreateDraftMutation',
}

export const useCreateDraftMutation = () => {
  const { createDraft } = useServicesContext();
  return useMutation({
    mutationKey: [CreateDraftMutationCacheKey.CreateDraftMutation],
    mutationFn: ({ article }: { article: ArticleDraftRequest }) =>
      createDraft({ article }),
  });
};
